export const ROW_LIMIT: Record<string, number> = {
    "plasmid": 500,
    "indel_performance": 500,
    "western_blot": 500,
    "guide": 5000,
    "gen_gen_plate": 500,
    "s3_gen_gen_pair_level": 150000,
    "s3_gen_gen_cell_line_level": 150000,
    "s3_gen_gen_plate_level": 150000,
    "s3_gen_gen_combo_level": 150000,
    "vw_depmap_cellline_models_with_in_house_cellline": 150000,
    "vw_depmap_all_omics_with_in_house_cellline": 150000,
}